// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kfCJ","questions":"styles_questions__3I8Hf","footer":"styles_footer__2uqA_"};